import { uniqueId } from "lodash";
import React from "react";
import Stack from "../Stack";
import AuditItem from "./components/AuditItem";
import { jsx as _jsx } from "react/jsx-runtime";
function AuditTrail(_ref) {
  var items = _ref.items;
  var generateKey = function generateKey(item) {
    return "".concat(item.action, "-").concat(new Date(item === null || item === void 0 ? void 0 : item.dateTime).getTime(), "-").concat(uniqueId());
  };
  return /*#__PURE__*/_jsx(Stack, {
    children: items === null || items === void 0 ? void 0 : items.map(function (item) {
      return /*#__PURE__*/_jsx(AuditItem, {
        item: item
      }, generateKey(item));
    })
  });
}
export default AuditTrail;